import Button from 'antd/lib/button';
import Radio from 'antd/lib/radio';
import * as React from 'react';
import { useState } from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { RfqBidDetailsType } from '../../../SE.interfaces';
import SEFFBidCard from '../../../SEActions/SETasks/SEFFBidCard';
import RfqBidDetailsModal from './RfqBidDetailsModal';
import { RfqBidsStyles } from './RfqBids.styles';

const styles = () => ({ ...RfqBidsStyles() });

interface RfqBidsProps extends StylesProps<ReturnType<typeof styles>> {
  selectedBid: any;
  onBidSelection: (bid: any) => void;
  bidList: any;
  category: string;
  field: any;
  resetBids: () => void;
}

const RfqBids: React.FC<RfqBidsProps> = ({
  classes, selectedBid, bidList, onBidSelection, field, resetBids,
}) => {
  const [isBidDetailModalVisible, setIsBidDetailModalVisible] = useState<boolean>(false);
  const [bidDetailedData, setBidDetailedData] = useState<RfqBidDetailsType[]>();

  const handleViewDetails = (item) => {
    setBidDetailedData(item.bidDetailedData);
    setIsBidDetailModalVisible(true);
  };

  // Always render the full ranked list (selected bid highlighted) — mirrors the quote panel
  // (CHA / Surveyor) so the radios stay visible after a pick instead of collapsing to a single card.
  // Matched by bidId (not object identity) so a hydrated saved selection also highlights correctly.
  const renderSelectBid = () => {
    if (!bidList?.length) {
      return <div className={classes.noBid}>There is no bid available.</div>;
    }

    return (
      <Radio.Group
        className={classes.radioGroup}
        onChange={(e) => {
          const bid = bidList.find((item) => item.bidId === e.target.value);
          if (bid) onBidSelection(bid);
        }}
        value={selectedBid?.bidId}
        disabled={field?.disabled}
      >
        {bidList.map((item) => (
          <Radio
            className={classes.radio}
            value={item.bidId}
            key={item.bidId}
            disabled={field?.disabled}
          >
            <SEFFBidCard
              deviationFromL1={item.deviationFromL1}
              searchResult={item}
              extraContent={{
                isServiceNamePresent: true,
                isCutOffPresent: true,
              }}
              onViewDetails={() => handleViewDetails(item)}
            />
          </Radio>
        ))}
      </Radio.Group>
    );
  };

  const renderClearSelection = () => (
    !field?.disabled && selectedBid && (
      <div className={classes.changeSelection}>
        <Button type="link" className={classes.clearSelectionButton} onClick={resetBids}>
          Clear selection
        </Button>
      </div>
    )
  );

  const renderBidDetailModal = () => (
    <RfqBidDetailsModal
      onClose={() => setIsBidDetailModalVisible(false)}
      visible={isBidDetailModalVisible}
      bidDetails={bidDetailedData}
    />
  );

  return (
    <>
      {renderSelectBid()}
      {renderClearSelection()}
      {isBidDetailModalVisible && renderBidDetailModal()}
    </>
  );
};

export default withStyles(styles)(RfqBids);
